<template>
  <div id="scroll-next">
    <slot></slot>
  </div>
</template>

<script>
function getScrollXY() {
  var scrOfX = 0, scrOfY = 0;
  if( typeof( window.pageYOffset ) == 'number' ) {
      //Netscape compliant
    scrOfY = window.pageYOffset;
    scrOfX = window.pageXOffset;
  } else if( document.body && ( document.body.scrollLeft || document.body.scrollTop ) ) {
      //DOM compliant
    scrOfY = document.body.scrollTop;
    scrOfX = document.body.scrollLeft;
  } else if( document.documentElement && ( document.documentElement.scrollLeft || document.documentElement.scrollTop ) ) {
      //IE6 standards compliant mode
    scrOfY = document.documentElement.scrollTop;
    scrOfX = document.documentElement.scrollLeft;
  }
  return [ scrOfX, scrOfY ];
}

function getDocHeight() {
  var D = document;
  return Math.max(
    D.body.scrollHeight, D.documentElement.scrollHeight,
    D.body.offsetHeight, D.documentElement.offsetHeight,
    D.body.clientHeight, D.documentElement.clientHeight
  );
}

export default {
  name: 'scroll-next',
  methods: {
    handleScroll(event) {
      if (!this.loading && getDocHeight() == getScrollXY()[1] + window.innerHeight) {
        this.$emit('bottom')
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    console.log('Before Destroy')
    window.removeEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    console.log('Destroyed')
    window.removeEventListener('scroll', this.handleScroll);
  },
  updated() {
    console.log('Updated')
  }
}
</script>

<style>
#scroll-next {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
</style>
